import { put, takeLatest } from "redux-saga/effects";
import {
  GET_MY_FUNDS_DETAIL,
  GET_MY_FUNDS_DETAIL_INIT,
  GET_MY_FUNDS_DETAIL_SUCCESS,
  GET_MY_FUNDS_DETAIL_FAILED,
  UPLOAD_TEAR_SHEET,
  UPLOAD_TEAR_SHEET_INIT,
  UPLOAD_TEAR_SHEET_SUCCESS,
  UPLOAD_TEAR_SHEET_FAILED,
  INVESTORS_LIST_INIT,
  INVESTORS_LIST_SUCCESS,
  INVESTORS_LIST_FAILED,
  INVESTORS_LIST,
  UPDATE_MONTHLY_RETURN_INIT,
  UPDATE_MONTHLY_RETURN_SUCCESS,
  UPDATE_MONTHLY_RETURN_FAILED,
  UPDATE_MONTHLY_RETURN,
  SEARCH_PMRESULT,
  SEARCH_PMRESULT_INIT,
  SEARCH_PMRESULT_SUCCESS,
  SEARCH_PMRESULT_FAILED,
  SEARCH_RPRESULT,
  SEARCH_REPORTRESULT,
  SEARCH_REPORTRESULT_SUCCESS,
  SEARCH_REPORTRESULT_INIT,
  SEARCH_RPRESULT_SUCCESS,
  SEARCH_RPRESULT_FAILED,
  SEARCH_RPRESULT_INIT,
  SEARCH_REPORTRESULT_FAILED,
  GET_FUND_BIO_USER,
  GET_FUND_BIO_USER_INIT,
  GET_FUND_BIO_USER_SUCCESS,
  GET_FUND_BIO_USER_FAILED,
} from "./constants";
import { getUtil, postUtil, putUtil } from "../../services/axiosClient";
import { API } from "../../utils/Constant";

export function* getFundDetail({ id }) {
  yield put({ type: GET_MY_FUNDS_DETAIL_INIT });
  try {
    const res = yield getUtil(`${API.FundDetail}?id=${id}`);

    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_MY_FUNDS_DETAIL_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_MY_FUNDS_DETAIL_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* uploadTear({ payload, onSuccess, onCloseModal }) {
  yield put({ type: UPLOAD_TEAR_SHEET_INIT });
  try {
    const res = yield postUtil(`${API.TearSheetUpload}`, payload);

    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: UPLOAD_TEAR_SHEET_SUCCESS, payload: data.result });
      onSuccess();
      onCloseModal();
    } else {
      yield put({ type: UPLOAD_TEAR_SHEET_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* getInvestorsList({ id }) {
  yield put({ type: INVESTORS_LIST_INIT });
  try {
    const res = yield getUtil(`${API.GetInvestorList}?fundId=${id}`);
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: INVESTORS_LIST_SUCCESS,
        payload: data.result,
      });
    } else {
      yield put({ type: INVESTORS_LIST_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* updatePerformanceMatrix({ payload }) {
  yield put({ type: UPDATE_MONTHLY_RETURN_INIT });
  try {
    const res = yield putUtil(`${API.UpdateMonthlyReturn}`, payload);
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: UPDATE_MONTHLY_RETURN_SUCCESS,
        payload: data.result,
      });
    } else {
      yield put({ type: UPDATE_MONTHLY_RETURN_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}
export function* getPerformanceMetricsSearchResult({ payload }) {
  const { id, year } = payload || {};
  yield put({ type: SEARCH_PMRESULT_INIT });
  try {
    const res = yield getUtil(
      `${API.GetPerformanceMetricsSearchResult}?fundId=${id}&year=${year}`
    );
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: SEARCH_PMRESULT_SUCCESS,
        payload: data.result,
      });
    } else {
      yield put({ type: SEARCH_PMRESULT_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* GetRiskReportSearchResult({ payload }) {
  const { id } = payload || {};
  yield put({ type: SEARCH_RPRESULT_INIT });
  try {
    const res = yield getUtil(
      `${API.GetRiskReportSearchResult}?fundId=${id}`
    );
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: SEARCH_RPRESULT_SUCCESS,
        payload: data.result,
      });
    } else {
      yield put({ type: SEARCH_RPRESULT_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* RiskReportSearchResultByMonth({ payload }) {
  const { id, month, riskReportType } = payload || {};
  yield put({ type: SEARCH_REPORTRESULT_INIT });
  try {
    const res = yield getUtil(
      `${API.RiskReportSearchResultByMonth}?fundId=${id}&month=${month}&riskReportType=${riskReportType}`
    );
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: SEARCH_REPORTRESULT_SUCCESS,
        payload: data.result,
      });
    } else {
      yield put({ type: SEARCH_REPORTRESULT_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}
export function* getFundBioUsersSaga({ id }) {
  yield put({ type: GET_FUND_BIO_USER_INIT });
  try {
    const res = yield getUtil(`${API.fundBioUsers}?tenantId=${id}`);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_FUND_BIO_USER_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_FUND_BIO_USER_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}
export function* fundDetail() {
  yield takeLatest(GET_MY_FUNDS_DETAIL, getFundDetail);
  yield takeLatest(UPLOAD_TEAR_SHEET, uploadTear);
  yield takeLatest(INVESTORS_LIST, getInvestorsList);
  yield takeLatest(UPDATE_MONTHLY_RETURN, updatePerformanceMatrix);
  yield takeLatest(SEARCH_PMRESULT, getPerformanceMetricsSearchResult);
  yield takeLatest(SEARCH_RPRESULT, GetRiskReportSearchResult);
  yield takeLatest(SEARCH_REPORTRESULT, RiskReportSearchResultByMonth);
  yield takeLatest(GET_FUND_BIO_USER, getFundBioUsersSaga);
}
